import React from "react"
import Flex from "@irati/ui/src/Flex"
import {RecognitionAutomation} from "@irati/types"
import AutomationCountryItem from "./AutomationCountryItem"
interface AutomationCountryListProps {
  recognitionAutomations: RecognitionAutomation[]
}
const sortAutomationsByRegion = (automationsList: RecognitionAutomation[]) => {
  const list = Array.from(automationsList).sort((a, b) => {
    const aRegion = a.region?.teamName.replace("platform.billingUnit.", "")
    const bRegion = b.region?.teamName.replace("platform.billingUnit.", "")
    if (aRegion < bRegion) {
      return -1
    }
    if (aRegion > bRegion) {
      return 1
    }
    return 0
  })

  return list
}
const AutomationCountryList = (props: AutomationCountryListProps) => {
  const automationsList = sortAutomationsByRegion(props.recognitionAutomations)
  return (
    <Flex direction="column" gap={2} marginTop={2}>
      {automationsList?.map((recognitionAutomation) => (
        <AutomationCountryItem key={recognitionAutomation.uuid} recognitionAutomation={recognitionAutomation} />
      ))}
    </Flex>
  )
}

export default AutomationCountryList
